// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3qaDS","legacyBtn":"MutateMid_legacyBtn__1k3dF"};